export default "__VITE_ASSET__D6GMpm76__"